<template>
    <v-container fluid class="pa-0">
    <v-select :items="typeListByGroup['QIZ']" item-text="typ_name" item-value="typ_id" outlined dense
        v-model="qizTypId" label="Type de champ" >
    </v-select>
    <v-treeview 
            :items="itemsTree"
            :search="search"
            item-text="qiz_name" item-key="qiz_id"
            hoverable activatable open-on-click> <!-- :filter="filter" :open.sync="treeViewopen"  -->
            <template v-slot:prepend="{ item }">
            <v-icon v-if="item.children">
                {{  typeListById[item.qiz_typ_id_field].typ_icon }}
            </v-icon>
            </template>
            <template v-slot:label="{ item }">{{item.qiz_name}} {{ (item.qiz_description) ? '(' + item.qiz_description + ')' : '' }}</template>
            <template v-slot:append="{ item }">
                <v-chip v-show="(item.qiz_value)" class="ma-1" label color="secondary">{{ item.qiz_value }}</v-chip>
                <v-btn depressed class="ml-2 rounded-xl" color="amber darken-1" :href="'/#/quizzes/' + item.qiz_id + ''">
                    <v-icon left class="mr-2">mdi-pencil</v-icon>Editer
                </v-btn>
            </template>
    </v-treeview>
    <!--<v-data-table v-bind:headers="headers" :items="itemList" item-key="id" :search="search"
        items-per-page-text="Lignes par page" hide-default-header
        :items-per-page-options="pagination.rowsPerItem">
        <template v-slot:top>
            <v-row class="rounded-lg ma-0 pa-0">
                <v-col cols="6" md="6" class="pa-1">
                <v-text-field append-icon="mdi-magnify" label="Recherche" outlined dense clearable single-line
                            hide-details v-model="search" @blur="saveSearchToCache()" class="pa-2 rounded-xl">
                </v-text-field>
                </v-col>
            </v-row>
        </template>
        <template v-slot:[`item.qiz_name`]="{ item }"><v-chip class="ma-2" color="secondary">{{ item.qiz_name }}</v-chip><v-icon>mdi-arrow-right</v-icon></template>
        <template v-slot:[`item.qiz_id`]="{ item }">
            <v-btn v-if="$root.$permissions.Quiz.update" rounded :href="'/#/quizzes/' + item.qiz_id + ''" color="orange" elevation="0" dark>
                <v-icon left  v-if="$root.$permissions.Quiz.update" >{{item.qiz_id}} mdi-pencil</v-icon> Fiche
            </v-btn>
        </template>
        <template v-slot:no-data>
        <v-alert :value="( !itemList.lenght )" color="error" icon="mdi-alert">
            Aucun evenement
        </v-alert>
        </template>
    </v-data-table>
    -->
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useQuizStore } from '@/stores/quiz'
import { useTypeStore } from '@/stores/type'

export default {
    name: 'quizzes-list',
    computed: {
        ...mapState(useQuizStore, {itemList: 'itemList' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
    },
    data: function () {
        return {
            search: '',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            qizTypId: 'QIZ01',
            headers: [
                { text: 'Nom',    value: 'qiz_name', align: 'left'},
                { text: 'Type',   value: 'qiz_typ_id', align: 'left'},
                { text: 'Action', value: 'qiz_id', align: 'right'},
            ],
            itemsTree: [],
        }
    },
    async mounted () {
        await this.fetchItems('?per_page=false')
        this.itemsTree = this.list_to_tree(this.itemList)
    },
    methods: {
        ...mapActions(useQuizStore, {fetchItems: 'fetchItems'}),
        list_to_tree(list) {
            var map = {}, node, roots = [], i;
            
            for (i = 0; i < list.length; i += 1) {
                map[list[i].qiz_id] = i; // initialize the map
                list[i].children = []; // initialize the children
            }
            
            for (i = 0; i < list.length; i += 1) {
                node = list[i];
                if (node.qiz_id_parent) {
                    // if you have dangling branches check that map[node.parentId] exists
                    list[map[node.qiz_id_parent]].children.push(node);
                } else {
                    roots.push(node);
                }
            }
            return roots;
        }
    },
}
</script>